<div class="main">
  <router-outlet #myOutlet="outlet"></router-outlet>
  <div [hidden]="myOutlet.isActivated">
    <div class="wrap">
      <div class="spin">
        <kendo-loader
          [type]="loader.type"
          [themeColor]="loader.themeColor"
          [size]="loader.size"
        >
        </kendo-loader>
      </div>
    </div>
  </div>
  <app-footer></app-footer>
</div>